import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { styled } from '@mui/system';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';

// ✅ Styled components
const Root = styled('div')({
  padding: '20px',
  fontFamily: 'Inter, sans-serif',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
});

const Sidebar = styled('div')({
  width: 'auto',
  marginBottom: '20px',
  padding: '10px 0',
  borderBottom: '1px solid #e0e0e0',
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
  alignItems: 'right',
});

const MainDescription = styled('p')({
  fontSize: '1rem',
  color: '#000',
  marginBottom: '30px',
});

const SectionHeading = styled('h3')({
  fontSize: '22px',
  color: '#000',
  marginTop: '15px',
});

const SectionDescription = styled('p')({
  fontSize: '0.9rem',
  color: '#000',
});

const ReportList = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  borderRadius: '8px',
});

const ReportListItem = styled('li')(({ favorite }) => ({
  margin: '10px 0',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: favorite
    ? '0 4px 8px rgba(0,0,0,0.15)'
    : '0 2px 4px rgba(0,0,0,0.05)',
  display: 'flex',
  justifyContent: 'space-between',
}));

const ContentHalf = styled('div')({
  backgroundColor: '#ffffff',
  padding: '15px',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  borderRadius: '8px 0 0 8px',
});

const ReportLink = styled('a')({
  textDecoration: 'none',
  color: 'green',
  fontSize: '20px',
  fontWeight: 'bold',
  display: 'block',
  marginBottom: '5px',
});

const SubReportQuestion = styled('p')({
  fontSize: '0.95rem',
  color: '#000',
  margin: 0,
});

const FavoriteStarWrapper = styled('div')({
  float: 'right',
  width: '35px',
  height: '35px',
  borderRadius: '5px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const FavoriteStar = styled('span')(({ active }) => ({
  color: active ? 'gold' : 'green',
  fontSize: '1.4rem',
}));

class EssentialReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      pagename: '',
      activeTab: 'allReports',
      favorites: JSON.parse(localStorage.getItem('favoriteReports')) || [],
      reports: [
        {
          category: 'Essential Reports',
          description: 'For you and your accountant, to understand the current state of your business',
          items: [
            { name: 'Profit and Loss Report - Standard', question: 'How much profit I have made?', href: '/#/Profitlossreports' },
            { name: 'Profit and Loss Report - Comparative', question: 'How much profit I have made in the current financial year? How does it compare to the previous year?', href: '/#/Comparativeprofitandloss' },
            { name: 'Balance Sheet', question: 'How much are my assets and liablities worth?', href: '/#/Balancereport' },
            { name: 'Trial Balance Report', question: 'What is the balance for each ledger account?', href: '/#/Trialbalancereport' },
            { name: 'Account Receivable(A/R) Aging Report Day Book Report', question: 'Who owes money to me?', href: '/#/Accountsrecievablereport' },
            { name: 'Accounts Payable (A/P) Aging Report', question: 'Who do i owe money to?', href: '/#/Accountspayablereport' },
			{ name: 'General Ledger Report', question: 'What are all the transactions for a specific ledger account?', href: '/#/TransactionsLedgerReport' },
          ],
        },
        {
          category: 'Cash Reports',
          description: 'Help you to manage your money and understand your cash flow.',
          items: [
            { name: 'Vendor Cash Flow Forecast', question: 'How much cash in and out should i expect?', href: '/#/Vendordashboard' },
            { name: 'Customer Cash Flow Forecast', question: 'How much actual cash came in and out?', href: '/#/Salesdashboard' },
            //{ name: 'Reciepts and Payments Day Book', question: 'What payments did i send and receive?', href: '#' },
          ],
        },
        {
          category: 'Detailed Reports',
          description: 'Detailed list for you to review.',
          items: [
            { name: 'Sales Day Book', question: 'What were my sales?', href: '/#/Salesdaybookreport' },
            { name: 'Purchase Day Book', question: 'What were my purchase?', href: '/#/purchasedaybookreport' },
            { name: 'Profit Analysis', question: 'How much profit did i make on each of my sales?', href: '/#/Profitanalysisreport' },
            { name: 'Sales Revenue - Product & Services', question: 'What was my revenue from sales of products and services?', href: '/#/Salesrevenuereport' },
            { name: 'Audit Trial', question: 'What took place during a specified date range?', href: '/#/Auditrail' },
            { name: 'Chart of Accounts', question: 'What ledger accounts are set up?', href: '/#/Chartofaccount' },
          ],
        },
        {
          category: 'Tax Report',
          description: '',
          items: [
            { name: 'Sales Tax Report', question: 'How much sales tax do i owe?', href: '/#/Saletaxreport' },
            { name: '1099 vendor Report', question: 'How much i paid my 1099 Vendors?', href: '/#/Vendor1099Report' },
          ],
        },
        {
          category: 'Products & Service Reports',
          description: '',
          items: [
            { name: 'Stock Movements', question: 'What stock item came in and out during given period?', href: '/#/Inventorystockmovementreport' },
          ],
        },
      ],
    };
  }

  componentDidMount() {
    document.title = "Essential Reports";
    if (localStorage.getItem("ISIuserid") == null) {
      this.setState({ redirect: true, pagename: '/Login' });
    }
  }

  toggleFavorite = (reportName) => {
    this.setState(prevState => {
      const { favorites } = prevState;
      let newFavorites;
      if (favorites.includes(reportName)) {
        newFavorites = favorites.filter(name => name !== reportName);
      } else {
        newFavorites = [...favorites, reportName];
      }
      localStorage.setItem('favoriteReports', JSON.stringify(newFavorites));
      return { favorites: newFavorites };
    });
  };

  renderReportItem = (report) => {
    const isFavorite = this.state.favorites.includes(report.name);
    return (
      <ReportListItem key={report.name} favorite={isFavorite}>
        <ContentHalf>
          <ReportLink href={report.href}>{report.name}</ReportLink>
          <SubReportQuestion>{report.question}</SubReportQuestion>
        </ContentHalf>
        <FavoriteStarWrapper onClick={() => this.toggleFavorite(report.name)}>
          <FavoriteStar active={isFavorite ? 1 : 0}>
            {isFavorite ? <StarIcon /> : <StarBorderIcon />}
          </FavoriteStar>
        </FavoriteStarWrapper>
      </ReportListItem>
    );
  };

  renderReports = () => {
    const { activeTab, reports, favorites } = this.state;

    let displayedReports = [];
    if (activeTab === 'allReports') {
      displayedReports = reports;
    } else if (activeTab === 'favorites') {
      displayedReports = reports.map(category => ({
        ...category,
        items: category.items.filter(item => favorites.includes(item.name))
      })).filter(category => category.items.length > 0);
    }

    const leftColumnCategories = ['Essential Reports', 'Cash Reports'];
    const rightColumnCategories = ['Detailed Reports', 'Tax Report', 'Products & Service Reports'];

    const getCategoriesForColumn = (columnCategories) => {
      return columnCategories.map(categoryName => {
        const foundCategory = displayedReports.find(cat => cat.category === categoryName);
        return foundCategory || { category: categoryName, description: '', items: [] };
      }).filter(category => category.items.length > 0);
    };

    const leftColumnData = getCategoriesForColumn(leftColumnCategories);
    const rightColumnData = getCategoriesForColumn(rightColumnCategories);

    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
        <div style={{ flex: '1 1 48%', minWidth: '300px' }}>
          {leftColumnData.map((category, index) => (
            <div key={index}>
              <SectionHeading>{category.category}</SectionHeading>
              {category.description && <SectionDescription>{category.description}</SectionDescription>}
              <ReportList>
                {category.items.map(report => this.renderReportItem(report))}
              </ReportList>
            </div>
          ))}
        </div>
        <div style={{ flex: '1 1 48%', minWidth: '300px' }}>
          {rightColumnData.map((category, index) => (
            <div key={index}>
              <SectionHeading>{category.category}</SectionHeading>
              {category.description && <SectionDescription>{category.description}</SectionDescription>}
              <ReportList>
                {category.items.map(report => this.renderReportItem(report))}
              </ReportList>
            </div>
          ))}
        </div>
      </div>
    );
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.pagename} />;
    }

    return (
  
       
        <div className="tabbox">
          <p>
            Use reports to view your company and financial information at a glance.
          </p>
          {this.renderReports()}
        </div>
     
    );
  }
}

export default EssentialReports;
